import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import toast from 'react-hot-toast';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Stack } from '@mui/material';

export default function QuestionDialog({ open, setOpen, addQuestion }) {
  const [question, setQuestion] = React.useState({ tag: '', label: '', type: '' });

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    if (!question.tag || !question.label || !question.type) return toast.error('Please fill all required fields');
    const isAdded = addQuestion(question);

    if (isAdded) {
      setQuestion({ tag: '', label: '', type: '' });
      setOpen(false);
    } else {
      toast.error(`Tag "${question.tag}" is duplicated, please use another tag.`);
    }
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Add New Question</DialogTitle>
        <DialogContent>
          <DialogContentText>Tagging is the key for each question</DialogContentText>
          <TextField
            onChange={(e) => setQuestion({ ...question, tag: e.currentTarget.value.replace(/\s+/g, '').toLowerCase() })}
            required
            margin='dense'
            id='tag'
            label='Tagging'
            type='text'
            fullWidth
            variant='standard'
            value={question?.tag?.replace(/\s+/g, '').toLowerCase()}
          />
          <TextField
            onChange={(e) => setQuestion({ ...question, label: e.currentTarget.value })}
            required
            autoFocus
            margin='dense'
            id='label'
            label='Label'
            type='text'
            fullWidth
            variant='standard'
            value={question.label}
          />
          <FormControl sx={{ marginTop: 2 }}>
            <FormLabel id='type'>Type *</FormLabel>
            <RadioGroup
              aria-labelledby='demo-radio-buttons-group-label'
              value={question.type}
              name='radio-buttons-group'
              onChange={(e) => setQuestion({ ...question, type: e.currentTarget.value })}
            >
              <FormControlLabel value='text' control={<Radio />} label='Text' />
              <FormControlLabel value='multiple-text' control={<Radio />} label='Multiple Text' />
              <FormControlLabel value='radio' control={<Radio />} label='Radio' />
              <FormControlLabel value='checkbox' control={<Radio />} label='Checkbox' />
              <FormControlLabel value='html' control={<Radio />} label='HTML' />
              <FormControlLabel value='attachment' control={<Radio />} label='Attachments' />
              <FormControlLabel value='thumbnail' control={<Radio />} label='Photo' />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <Stack direction='row' justifyContent='flex-end' m={2}>
          <Stack direction='row'>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={handleSave}>Save</Button>
          </Stack>
        </Stack>
      </Dialog>
    </div>
  );
}
